import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { columnas } from "./columns";
import { CancelarFactura } from "app/features/general/operativa/items/facturas/cancelacion";
import { Multiselector } from "app/features/componentes/multiselector";

type Entity = models.FacturaDto;
export interface Props {
    value?: number[];
    onChange?: (x: number[]) => void;
    items: Entity[];
}


/**
* Listado de ContrareciboDto
*/
class ContrareciboDtoListNoRx extends React.PureComponent<Props> {
    modalManager = kea.createModalManager();

    onCancelar = async (x: Entity) => {
        await CancelarFactura(x.IdRegistro, this.modalManager.showModal);
    }
    onReimprimir = async (x: Entity) => {

    }
    onTimbrar = async (x: Entity) => {
        if (await kea.yesno("¿Timbrar factura?", "" + x.SerieFolio)) {
            await resources.Factura.TimbrarFactura(x.IdRegistro);
            await kea.message("La factura ha sido timbrada");
        }
    }

    OnObtenerPDF = async (x: Entity) => {
        const facturaPDF = await resources.Factura.ObtenerPDF(x.IdRegistro);
        kea.openPdf(kea.base64ToBlob(facturaPDF, 'application/pdf'), `Factura  ${x.SerieFolio}.pdf`);
    }

    OnObtenerPDFDetalleCobranza = async (x: Entity) => {
        const facturaPDF = await resources.Factura.ObtenerReporteDetalleCobranza(x.IdRegistro);
        kea.openPdf(kea.base64ToBlob(facturaPDF, 'application/pdf'), `Detalle cobranza Factura  ${x.SerieFolio}.pdf`);
    }

    onVer = async (x: Entity) => {
        history.go("operativa/facturas/" + x.IdRegistro);
    }

    render() {
        const cols = columnas(this);
        return (
            <div>
                {
                    this.props.onChange ?
                        <Multiselector
                            value={this.props.value || []}
                            onChange={this.props.onChange}
                            getKey={(x: Entity) => x.IdRegistro}
                            items={this.props.items}
                            columnas={cols} /> :
                        <kea.Grid2
                            getKey={(x: Entity) => x.IdRegistro}
                            items={this.props.items}
                            columnas={cols}
                        />
                }

                {this.modalManager.component}
            </div>
        );
    }
}

export const ContrareciboDtoList = componentToRx(ContrareciboDtoListNoRx);


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cobranza/contrarecibos/list/listmem.tsx